import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const isEditableTarget = (target) => {
  if (!target || !target.closest) return false;
  return Boolean(target.closest('input, textarea, select, [contenteditable="true"], .allow-copy'));
};

const isProtectedMediaTarget = (target) => {
  if (!target || !target.closest) return false;
  return Boolean(target.closest('img, video, iframe, canvas, svg'));
};

const ContentProtection = () => {
  useEffect(() => {
    let mounted = true;
    let cleanup = () => {};

    const blockIfPublicContent = (event) => {
      if (isEditableTarget(event.target)) return;
      event.preventDefault();
    };

    const blockMediaDrag = (event) => {
      if (!isProtectedMediaTarget(event.target)) return;
      event.preventDefault();
    };

    const blockShortcutCopying = (event) => {
      if (isEditableTarget(event.target)) return;
      const key = event.key?.toLowerCase();
      const isModifier = event.ctrlKey || event.metaKey;
      const blockedKeys = ['c', 'x', 's', 'u', 'p'];

      if (isModifier && blockedKeys.includes(key)) {
        event.preventDefault();
      }
    };

    const applySettings = async () => {
      try {
        const response = await axios.get(`${API}/settings/content-protection`);
        if (!mounted) return;
        const settings = response.data.settings || {};
        if (!settings.enabled) return;

        document.body.classList.add('content-protected');

        if (settings.disable_copy) {
          document.addEventListener('copy', blockIfPublicContent);
          document.addEventListener('cut', blockIfPublicContent);
          document.addEventListener('selectstart', blockIfPublicContent);
          document.addEventListener('keydown', blockShortcutCopying);
        }
        if (settings.disable_drag) {
          document.addEventListener('dragstart', blockMediaDrag);
        }
        if (settings.disable_right_click) {
          document.addEventListener('contextmenu', blockIfPublicContent);
        }

        cleanup = () => {
          document.body.classList.remove('content-protected');
          document.removeEventListener('copy', blockIfPublicContent);
          document.removeEventListener('cut', blockIfPublicContent);
          document.removeEventListener('selectstart', blockIfPublicContent);
          document.removeEventListener('dragstart', blockMediaDrag);
          document.removeEventListener('keydown', blockShortcutCopying);
          document.removeEventListener('contextmenu', blockIfPublicContent);
        };
      } catch (error) {
        // Keep the public site usable if settings cannot load.
      }
    };

    applySettings();

    return () => {
      mounted = false;
      cleanup();
    };
  }, []);

  return null;
};

export default ContentProtection;
